import { Component } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { MatDialogRef } from '@angular/material';
import { APPCONFIG } from '../../../app/main/config';

@Component({
    selector: 'warehouse-document-preview-dialog',
    templateUrl: './warehouse-document-preview-dialog.component.html?v=${APPCONFIG.cacheVersion}',
    styleUrls: ['./warehouse-document-preview-dialog.component.scss?v=${APPCONFIG.cacheVersion}']
})
export class WarehouseDocumentPreviewDialogComponent {
    public title: string;
    public isPdf = false;
    public objectUrl: any;

    private rawObjectUrl: string;

    constructor(public dialogRef: MatDialogRef<WarehouseDocumentPreviewDialogComponent>, private domSanitizer: DomSanitizer) {
        dialogRef.disableClose = true;
    }

    /** Renders the given blob; call once after opening the dialog. */
    show(blob: Blob, contentType: string, title: string): void {
        this.title = title;
        this.isPdf = (contentType || '').indexOf('pdf') !== -1;
        this.revoke();
        this.rawObjectUrl = URL.createObjectURL(blob);
        this.objectUrl = this.domSanitizer.bypassSecurityTrustResourceUrl(this.rawObjectUrl);
    }

    close(): void {
        this.revoke();
        this.dialogRef.close();
    }

    private revoke(): void {
        if (this.rawObjectUrl) {
            URL.revokeObjectURL(this.rawObjectUrl);
            this.rawObjectUrl = null;
        }
    }
}
